module.exports = __webpack_public_path__ + "img/person-cold.0db0c87d.gif";